import React from 'react';
import { Button, Icon, Skeleton, Tooltip } from '@fourthwall/components';
import { QuestionMarkIcon } from '@fourthwall/icons';
import { calculateValuePercentageChange } from '../../../../utils/calculateValuePercentageChange';
import { AnalyticsChangeIndicator } from '../../../AnalyticsChangeIndicator/AnalyticsChangeIndicator';
import { AnalyticsExternalSourceIcon } from '../../../AnalyticsExternalSourceIcon/AnalyticsExternalSourceIcon';
import * as S from './AnalyticsCardHeading.styled';
export const AnalyticsCardHeading = ({ type, title, titleTooltip, externalSource, subtitle, value, formatValue, reportLink, isLoading, }) => {
    const displayValue = (value) => (formatValue ? formatValue(value) : value);
    if (isLoading) {
        return React.createElement(AnalyticsCardHeadingSkeleton, { type: type });
    }
    const renderValue = () => {
        if (!value) {
            return null;
        }
        const hasComparableValue = Array.isArray(value);
        if (hasComparableValue) {
            const changeValue = calculateValuePercentageChange(value);
            return (React.createElement(React.Fragment, null,
                React.createElement(S.Value, null, displayValue(value[0])),
                React.createElement(AnalyticsChangeIndicator, { value: changeValue, showZero: false })));
        }
        return React.createElement(S.Value, null, displayValue(value));
    };
    const getReportLinkProps = () => {
        if (!reportLink)
            return null;
        if (typeof reportLink === 'object' && 'to' in reportLink) {
            return { to: reportLink.to, state: reportLink.state };
        }
        return { to: reportLink };
    };
    const reportLinkProps = getReportLinkProps();
    return (React.createElement(S.Container, null,
        React.createElement(S.Content, null,
            React.createElement(S.TitleContainer, null,
                React.createElement(S.Title, null,
                    React.createElement(AnalyticsExternalSourceIcon, { externalSource: externalSource }),
                    title,
                    titleTooltip && (React.createElement(Tooltip, { reference: React.createElement(Icon, { component: QuestionMarkIcon, height: 14 }) }, titleTooltip))),
                React.createElement(S.Subtitle, null, subtitle)),
            reportLinkProps && (React.createElement(Button, { appearance: "secondary", size: "xsmall", label: "Full report", ...reportLinkProps }))),
        React.createElement(S.ValueContainer, null, renderValue())));
};
const AnalyticsCardHeadingSkeleton = ({ type }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Content, null,
            React.createElement(S.TitleContainer, null,
                React.createElement(S.Title, null,
                    React.createElement(Skeleton.Shape, { width: 200, height: 24 })),
                type === 'stats' && (React.createElement(S.Subtitle, null,
                    React.createElement(Skeleton.Shape, { width: 140, height: 20 })))),
            React.createElement(Skeleton.Shape, { width: 110, height: 32 })),
        React.createElement(S.ValueContainer, null, type === 'lineChart' && (React.createElement(S.Value, null,
            React.createElement(Skeleton.Shape, { width: 120, height: 36 }))))));
};
